//read more read less feature
document.addEventListener('DOMContentLoaded', function() {
  var toggleLink = document.getElementById('toggle-description');
  var shortDescription = document.getElementById('short-description');
  var fullDescription = document.getElementById('full-description');
  var section = document.getElementById('custom-product-description');

  toggleLink.addEventListener('click', function(event) {
    event.preventDefault();

    if (fullDescription.classList.contains('hidden')) {

      fullDescription.classList.remove('hidden');
      shortDescription.classList.add('hidden');
      toggleLink.textContent = 'Read less';

    } else {

      fullDescription.classList.add('hidden');
      shortDescription.classList.remove('hidden');
      toggleLink.textContent = 'Read more';

      // ✅ Correct scroll calculation
      if (section) {
        const y = section.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: y - 120, // adjust if header exists
          behavior: 'smooth'
        });
      }
    }
  });
});
//read more read less feature